// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"19bdff9a","977":"9a6a9dbf"}[chunkId] + ".chunk.js";
};